import { Divider } from 'components/ui/Divider';
import { useDialog } from 'hooks/useDialog';
import React, { useEffect, useState } from 'react';

// Interface basée sur votre FilterItemDto
interface FilterItemDto {
  id: string;
  label: string;
  code: string;
  count: number;
}

interface FilterGroupProps {
  title: string;
  items: FilterItemDto[];
  multiSelect?: boolean;
  showCount?: boolean;
  className?: string;
}

const FilterGroup: React.FC<FilterGroupProps> = ({
  title,
  items,
  multiSelect = true,
  showCount = false,
  className = '',
}) => {
  const [internalSelection, setInternalSelection] = useState<string[]>([]);

  const currentSelection = internalSelection;

  const { setDialogActions } = useDialog()

  useEffect(() => {
    setDialogActions({
      submitLabel: "Valider",
      closeLabel: "Fermer",
      onSubmit: () => { }
    })
  }, [setDialogActions])

  const handleItemClick = (itemId: string) => {
    let newSelection: string[];

    if (multiSelect) {
      if (currentSelection.includes(itemId)) {
        newSelection = currentSelection.filter(id => id !== itemId);
      } else {
        newSelection = [...currentSelection, itemId];
      }
    } else {
      newSelection = currentSelection.includes(itemId) ? [] : [itemId];
    }

    setInternalSelection(newSelection);
    // onSelectionChange?.(newSelection);
  };

  const isSelected = (itemId: string) => currentSelection.includes(itemId);

  return (
    <div className={`${className}`}>
      <h3 className="text-lg font-bold text-primary mb-2">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => handleItemClick(item.id)}
            className={`
              px-3 group py-1 rounded-full border transition-all duration-200 text-sm font-medium
              ${isSelected(item.id)
                ? 'bg-primary text-white border-primary shadow-md'
                : 'bg-white text-gray-700 border-gray-300 hover:border-primary hover:bg-primary hover:text-white'
              }
              hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50
            `}
            title={`${item.label}${showCount ? ` (${item.count})` : ''}`}
          >
            {item.label}
            {showCount && (
              <span className={`ml-2 text-xs ${isSelected(item.id) ? 'text-white' : 'text-gray-500 group-hover:text-white'}`}>
                ({item.count})
              </span>
            )}
          </button>
        ))}
      </div>
      <Divider className='mt-6 mb-4'/>
    </div>
  );
};

export default FilterGroup
